import { render } from "./HandleViewFooter.vue?vue&type=template&id=2c1cbf9a&scoped=true"
import script from "./HandleViewFooter.vue?vue&type=script&lang=js"
export * from "./HandleViewFooter.vue?vue&type=script&lang=js"

import "./HandleViewFooter.vue?vue&type=style&index=0&id=2c1cbf9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1cbf9a"]])

export default __exports__